import Metric, { NumericType, TimeType } from "src/shared/models/metric";
import { FilterableField } from "src/shared/models/pipeline-config/reporting-sets.models";
import { MetricComponent } from "../../../shared/models/pipeline-config/metric-definition.models";
import { MetricTypes } from "../../../shared/models/pipeline-config/mongo-enums.model";

export interface SelectorMetric extends Metric {
    Description: string;
    MetricType: MetricType;
    TimeTypeOverride: TimeType;
    RecGroups: string;
    EmpGroups: string;
    MetricDefType: MetricTypes;
    Components: MetricComponent[];
    FormulaLoaded: boolean;
    CalculatedFormula: string;
    CanBeNegative: boolean;
    Formula?: string;
    ConversionType: string;
    DateParadigm?: string;

    QEAttributeFiltersByRSDef?: { [FieldName: string]: { [FieldName: string]: FilterableField } };
}

export interface AgentAttribute {
    AgentAttributeID: number;
    AttributeName: string;
}

export interface MetricSelectorData
{
    SelectorMetrics: SelectorMetric[];
    MetricCategories: string[];
    EmpSelector: GroupSelector;
    EmpSelectedToggle: boolean;
    EmpShowToggle: boolean;
    RecSelector: GroupSelector;
    RecSelectedToggle: boolean;
    RecShowToggle: boolean;
    AgentAttrSelectedToggle: boolean;
    AttrCategorySelectedToggle: boolean;
    SelectedMetrics: SelectorMetric[];
    TimeTypeOverrides: { [key: number]: number };
    FavoriteIdsOrder: number[];
    IsFavExpanded: boolean;
    MetricFilters: SelectorFilterMetric[];
    HasFilters: boolean;
    SlideMetricMax: number;
    LastMetricSelected?: number;
    DateParadigmNames?: { [key:number]: string };
}

export interface SelectedMetric extends SelectorMetric
{
    MetricID: number;
    EmpLevelMin?: number;
    RecLevelMin?: number;
    Abbreviation: string;
    MetricCustomName: string;
    NumericType: NumericType;
    TimeType: TimeType;
    TimeTypeOverride: TimeType;
    Formula?: string;
    DateFields?: string[];

    QEAttributeFiltersByRSDef?: { [FieldName: string]: { [FieldName: string]: FilterableField } };
}

export interface GroupSelector {
    SelectedGroupLevel: number;
}

export interface SelectorFilterMetric {
    Abbreviation?: string;
    MetricCustomName?: string;
    MetricID: number;
    MinValue: number;
    MaxValue: number;
    NumericType?: NumericType;
}

export interface FilterMetricsParams {
    //These will be used to filter the metrics that are displayed in the metric selector
    //If you need a filter that is not listed here, feel free to add it
    //Make sure to add it in the controller as well for it to work
    DefaultDirectionFilter?: number;
    ConversionTypeFilter?: string;
    filterRealTimeMetrics?: boolean;
    metricType?: string;
}

export enum MetricType {
    Disposition = 1,
    Product = 2,
    QA = 3,
    PO = 4,
    CurrentStatesMetricData = 5,
    Call = 6,
    Training = 7,
    Time = 8,
    Custom = 9,
    Derived = 10,
    Award = 11,
    Snapshot = 12,
    Attribute = 13,
}
